/**
 * Resolves a backend-served asset (image, file) to an absolute URL.
 *
 * Inputs:
 *   - "" / null / undefined          → ""
 *   - absolute "http(s)://..."       → returned as-is
 *   - "images/foo.png" or "/images/foo.png"
 *                                    → `${API_ORIGIN}/images/foo.png`
 *   - bare filename "foo.png" with `folder` → `${API_ORIGIN}/images/${folder}/foo.png`
 *
 * In dev, `VITE_API_BASE_URL` is the Laravel origin (default http://127.0.0.1:3001).
 * In prod the same env var points at the API host.
 */
const API_ORIGIN = (import.meta.env.VITE_API_BASE_URL || '').replace(/\/$/, '');

export function assetUrl(path?: string | null, folder?: string): string {
  if (!path) return '';
  const first = (String(path).split(',')[0] ?? '').trim();
  if (!first) return '';
  if (/^https?:\/\//i.test(first) || first.startsWith('data:') || first.startsWith('blob:')) {
    return first;
  }
  if (first.startsWith('/')) return `${API_ORIGIN}${first}`;
  if (first.startsWith('images/') || first.startsWith('storage/')) return `${API_ORIGIN}/${first}`;
  if (folder) return `${API_ORIGIN}/images/${folder.replace(/^\/+|\/+$/g, '')}/${first}`;
  return `${API_ORIGIN}/${first}`;
}
